<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="serialNo"
                  label="Serial No"
                  v-model="maintenanceFrequency.serialNo"
                  type="text"
                  :rules="rules.serialNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Name"
                  v-model="maintenanceFrequency.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="maintenanceFrequency.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="maintenanceFrequency.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="maintenanceFrequency.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="maintenanceFrequency.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="maintenanceFrequency.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="maintenanceFrequency.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="maintenanceFrequency.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="maintenanceFrequency.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || saveLoading"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
  
<script>
import { maintenanceFrequencyService } from "../../services/maintenance-frequency-service";
import { MaintenanceFrequency } from "../../models/model";
import { MaintenanceFrequencyFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";

export default {
  name: "MaintenanceFrequencyDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      {
        text: "Maintenance Frequency",
        disabled: false,
        to: "maintenance-frequencys",
      },
      {
        text: "Maintenance Frequency Detail",
        disabled: true,
      },
    ],
    maintenanceFrequency: new MaintenanceFrequency(),
    oldMaintenanceFrequency: new MaintenanceFrequency(),
    rules: new MaintenanceFrequencyFormRules(),
    updatedDate: "",
    createdDate: "",
    responseError: "",
    statusFlag: true,
  }),
  created() {
    const id = this.$route.params.id;
    if (id != "new") {
      //edit
      this.getMaintenanceFrequencyDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.maintenanceFrequency.status = this.statusFlag
            ? "ACTIVE"
            : "INACTIVE";
          maintenanceFrequencyService
            .saveMaintenanceFrequency(this.maintenanceFrequency)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    getMaintenanceFrequencyDetail(id) {
      maintenanceFrequencyService
        .getMaintenanceFrequencyDetail(id)
        .then((res) => {
          this.maintenanceFrequency = res.data;
          this.createdDate = commonService.millisecondToDate(
            this.maintenanceFrequency.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.maintenanceFrequency.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.oldMaintenanceFrequency = Object.assign({}, res.data);
          this.statusFlag =
            this.maintenanceFrequency.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.maintenanceFrequency.id) {
        this.maintenanceFrequency = new MaintenanceFrequency();
        this.statusFlag = true;
      } else {
        this.maintenanceFrequency = Object.assign(
          {},
          this.oldMaintenanceFrequency
        );
        this.statusFlag =
          this.maintenanceFrequency.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/maintenance-frequencys");
    },
  },
};
</script>
  
  